export default async (to, from, next) => {
  if (localStorage.getItem("token")) {
    next("/profile");
    return;
  }

  next();
};
